import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts, Validator, VRules, VConditions, ErrorMessage, ExchangeConverter } from '../../../components';
import { Rules, PaymentConfirm, Currencies, TransferOptionUrl } from '../../../components/Payment';
import { TransferOptionService } from '../../../services/TransferOptionService';
import { DepositService } from '../../../services/DepositService';

export class FastPay extends Component {

    constructor(props) {
        super(props)

        this.fastPayForm = React.createRef();
        this.Refs = React.createRef();

        this.state = {
            loading: true,
            confirm: false,
            paymentOptions: {
                acceptedCurrencies: [],
                description: "",
                rules: [],
                title: ""
            },
            // Payment Form
            login: 0,
            amount: 0,
            currency: "",
            fastPay: {
                merCd: "",
                merOrderNo: "",
                pageBackUrl: "",
                notifyUrl: "",
                signData: ""
            },
            validation: {
                error: false,
                message: ""
            }
        }

    }
    componentWillMount() {

        TransferOptionService.Deposit.OptionPage(TransferOptionUrl()).then(response => {

            if (!response) {
                document.location.href = "/deposit";
                return false;
            }

            this.setState({
                paymentOptions: response,
                loading: false,
                currency: response.acceptedCurrencies[0],
                error: false
            });
        });
    }
    changeAccount(userAccount) {
        this.setState({
            login: userAccount.active
        });
    }
    onChangeAmount(e) {
        this.setState({ amount: e.target.value });
    }
    onChangeCurrency(e) {
        this.setState({ currency: e.target.value });
    }
    onToggleDeposit() {
        if (this.isValid())
            this.setState(prevState => ({
                confirm: !prevState.confirm
            }));
    }
    onConfirmDeposit() {

        this.setState({ loading: true }, () => {

            DepositService.FastPay({
                login: this.state.login,
                amount: this.state.amount,
                currency: this.state.currency
            }).then((response) => {

                if (response.error) {

                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        },
                        loading: false
                    });
                }

                this.setState({
                    fastPay: response.data
                }, () => {

                    this.fastPayForm.current.submit();
                });
            });

        });
    }
    isValid() {

        VRules["amount"] = {
            Invalid: (value) => {
                return VConditions.Required(value) || VConditions.Min(value, 500)
            },
            Message: Translate("Invalid Amount")
        }


        if (!this.state.confirm) {

            let error = Validator.Valid({ amount: this.state.amount }, this.Refs);

            this.setState({
                validation: error
            });

            return !error.error;
        }

        return true;

    }
    render() {
        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Deposit")} SubUrl="/deposit" />
                        <Card Title={this.state.paymentOptions.title} Description={this.state.paymentOptions.description} Logo={this.state.paymentOptions.logo}>
                            <form id="fastPayForm" name="fastPayForm" method="POST" action="https://cup.cup-pay.com/pro_ebank/offline" ref={this.fastPayForm}>
                                <input type="hidden" name="merCd" value={this.state.fastPay.merCd} />
                                <input type="hidden" name="versionNo" value="V01" />
                                <input type="hidden" name="txnCd" value="T00400" />
                                <input type="hidden" name="merOrderNo" value={this.state.fastPay.merOrderNo} />
                                <input type="hidden" name="txnAmt" value={this.state.amount} />
                                <input type="hidden" name="pageBackUrl" value={this.state.fastPay.pageBackUrl} />
                                <input type="hidden" name="notifyUrl" value={this.state.fastPay.notifyUrl} />
                                <input type="hidden" name="remarks" value="" />
                                <input type="hidden" name="signType" value="HmacSHA1" />
                                <input type="hidden" name="signData" value={this.state.fastPay.signData} />
                            </form>
                            <div className="row">
                                <div className="col-md-12">
                                    <Rules Items={this.state.paymentOptions.rules} />
                                </div>
                                <ErrorMessage Validation={this.state.validation} />
                                {!this.state.confirm ?
                                    <div className="col-md-12">
                                        <form className="form-horizontal" name="depositForm" ref={this.Refs}>
                                            <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Payment Form")}</h4>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Account")}</label>
                                                <div className="col-sm-5">
                                                    <UserAccounts List className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} Status="deposit"/>
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="amount" className="col-sm-2 col-form-label">{Translate("Amount")}</label>
                                                <div className="col-sm-5">
                                                    <input className="form-control" type="number" id="amount" onChange={(e) => this.onChangeAmount(e)} placeholder="500 ¥" value={this.state.amount} onFocus={e => e.target.select()} />
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("Currency")}</label>
                                                <div className="col-sm-5">
                                                    <Currencies Items={this.state.paymentOptions.acceptedCurrencies} onChange={(e) => this.onChangeCurrency(e)} />
                                                </div>
                                            </div>
                                            <ExchangeConverter className="form-group row ml-3" Amount={this.state.amount} Currency={this.state.currency}/>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label"></label>
                                                <div className="col-sm-5">
                                                    <button type="button" className="btn btn-lg btn-success" onClick={(e) => this.onToggleDeposit()}>{Translate("Create a Deposit Request")}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    :
                                    <PaymentConfirm Form={[
                                        {
                                            title: Translate("Account"),
                                            value: this.state.login
                                        },
                                        {
                                            title: Translate("Amount"),
                                            value: this.state.amount.format('C') + " " + this.state.currency
                                        }
                                    ]} Cancel={(e) => this.onToggleDeposit()} Confirm={(e) => this.onConfirmDeposit()} />
                                }
                            </div>
                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}